import { useState } from 'react'
import { Icon } from '../Brand'
import AgentThread from '../UserWorkspace/AgentThread'
import { agentMeta } from '../UserWorkspace/agentMeta'

// The admin Chat tab: lets an admin test ONE agent at a time. Mirrors the
// UserWorkspace shell (agent selector + AgentThread) but with a compact
// horizontal pill selector. Reuses the same per-agent scoped /api/chat (each
// AgentThread sends { agent, sessionId, userId }), so the admin talks to a
// single selected agent rather than the combined orchestrator.
export default function AdminChat({ agents = [], user = null, session, onPersist = () => {} }) {
  const list = agents.filter((a) => a.enabled !== false)
  const [active, setActive] = useState(null)
  const activeName = active || list[0]?.name || null
  const activeAgent = list.find((a) => a.name === activeName)

  if (list.length === 0) {
    return (
      <div className="chat-empty" style={{ margin: 'auto' }}>
        <div className="cs-ic"><Icon name="forum" /></div>
        <p>Loading agents from the backend (GET /api/config)…</p>
      </div>
    )
  }

  return (
    <div className="admin-chat">
      <div className="admin-chat-tabs">
        {list.map((a) => {
          const meta = agentMeta(a.name)
          const on = a.name === activeName
          return (
            <button
              key={a.name}
              type="button"
              className={`ds-source ${on ? 'active' : ''}`}
              onClick={() => setActive(a.name)}
            >
              <Icon name={meta.icon} />
              {meta.label}
            </button>
          )
        })}
      </div>
      {activeAgent && (
        <AgentThread
          key={activeAgent.name}
          agent={activeAgent}
          user={user}
          session={session}
          onPersist={onPersist}
        />
      )}
    </div>
  )
}
